import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Customer from "./Pages/Customer";
import ViewCustomer from "./Pages/ViewCustomer";
import LoginPage from "./Pages/LoginPage";

const AppRoutes = () => {
  const isLogged = localStorage.getItem("loggedIn") === "true";

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={isLogged ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />}
        />

        <Route
          path="/login"
          element={isLogged ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />

        <Route
          path="/dashboard"
          element={isLogged ? <Dashboard /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/customer"
          element={isLogged ? <Customer /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/view-customer/:id"
          element={isLogged ? <ViewCustomer /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
